import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups } from '../store/slices/groupsSlice';

export const useGroups = (branchId, placeId) => {
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);
  const { loading } = useSelector((state) => state.groups);

  const fetchGroups = () => {
    if (!branchId) {
      setGroups([]);
      return;
    }

    dispatch(getGroups({ branchId, placeId })).unwrap()
      .then((data) => {
        setGroups(data?.items || data || []);
      })
      .catch(() => {
        setGroups([]);
      });
  };

  useEffect(() => {
    fetchGroups();
  }, [dispatch, branchId, placeId]);

  return {
    groups,
    loading,
    refetchGroups: fetchGroups
  };
}; 